import React, { type FC } from 'react';
import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@ui/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../hooks/useMediaQuery';

export interface BreadcrumbStep {
  title: string;
  route?: string;
  isCurrent?: boolean;
  isCompleted?: boolean;
}

export interface BreadcrumbProps {
  steps: BreadcrumbStep[];
  className?: string;
  onNavigate?: (route: string) => void;
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ steps, className, onNavigate }) => {
  const navigate = useNavigate();

  const handleNavigate = (route: string | undefined) => {
    if (!route) return;

    if (onNavigate) {
      onNavigate(route);
      return;
    }

    navigate(route);
  };
  const isMobile = useMediaQuery('(max-width: 768px)');
  // Hide breadcrumb on mobile
  if (isMobile) {
    return null;
  }

  return (
    <ShadcnBreadcrumb className={className}>
      <BreadcrumbList>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <BreadcrumbItem>
              {step.isCurrent ? (
                <BreadcrumbPage>{step.title}</BreadcrumbPage>
              ) : step.isCompleted ? (
                // Для завершенных шагов - кликабельный элемент с использованием React Router
                <button
                  onClick={() => handleNavigate(step.route)}
                  className="underline hover:text-primary cursor-pointer"
                >
                  {step.title}
                </button>
              ) : (
                // Незавершенные и не текущие шаги не кликабельны
                <span className="text-muted-foreground cursor-default">{step.title}</span>
              )}
            </BreadcrumbItem>

            {/* Добавляем разделитель после каждого элемента, кроме последнего */}
            {index < steps.length - 1 && <BreadcrumbSeparator />}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </ShadcnBreadcrumb>
  );
};
